/** @format */

import { Component, OnInit, inject } from '@angular/core';
import { IonButton, IonIcon } from '@ionic/angular/standalone';
import { UpdatesService } from '@app/core/services/updates.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-version-reload',
    templateUrl: './version-reload.component.html',
    styleUrls: ['./version-reload.component.scss'],
    standalone: true,
    imports: [IonIcon, IonButton]
})
export class VersionReloadComponent implements OnInit {
  private updatesService = inject(UpdatesService);

  public version: string;

  ngOnInit(): void {
    this.version = environment && environment.version ? 'v' + environment.version : '[dev]';
  }

  async presentReloadOptions() {
    return await this.updatesService.presentReloadOptions();
  }
}
